<li [ngClass]="{'active-step': active, 'finish-step': formSubmitted, 'app-wizard-header': true}">
    <app-tooltip [message]="getTooltipString()" [dynamic]="false" class="display-inline-flex">
        <span [class.iwp-icon-gen_info_ok]="hasSuccessIcon"
              [class.iwp-icon-gen_info_warning]="hasWarningIcon || hasErrorIcon"
              [class.error]="hasErrorIcon"
              class="header-icon"
              data-cy="wizard-header-tab-icon"></span>
    </app-tooltip>
    {{ label }}
</li>
